export default "<div class=\"loading\" *ngIf=\"show_loader\">\r\n    <div class=\"lds-dual-ring\"></div>\r\n</div>"